import { useQuery } from '@tanstack/react-query';
import { tenantConfigQueryOptions } from '@/lib/query/tenantConfigQuery';

export function useTenantConfig() {
  return useQuery(tenantConfigQueryOptions);
}
